import Recruit from './Recruit'

export default Recruit
